import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyGreetingCard = loadable(() => import(/* webpackChunkName: "content/greetingCard" */ '.'));
